import ISO_TO_COUNTRY_CODE from '../i18n/countryCodeMap.json';
import { COUNTRIES } from '../context/CountryContext';

// The document-requirements endpoint (aserver/api's
// config/driverDocumentRequirements.ts) wants a real ISO alpha-2 code, but
// CountryContext's own country codes are name-based (e.g. 'GERMANY') for
// the site's language/theater picker - this cross-references the two so
// the driver application form can show real country names (from COUNTRIES'
// own labels) while still submitting a real ISO code underneath.
const NAME_TO_LABEL = new Map(COUNTRIES.map((c) => [c.code, c.label]));

function titleCase(name) {
  return name.charAt(0) + name.slice(1).toLowerCase();
}

export const DRIVER_COUNTRY_OPTIONS = Object.entries(ISO_TO_COUNTRY_CODE)
  .map(([iso, name]) => ({
    iso,
    label: NAME_TO_LABEL.get(name) || titleCase(name),
  }))
  .sort((a, b) => a.label.localeCompare(b.label));
